webpackJsonp([34278247173053],{

/***/ 1484:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"OrgDepartmentInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-org-department-input-d181f444a421a7dd248f.js